import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../../forum/app';
import FormModal from '../../common/components/FormModal';
import Button from '../../common/components/Button';
import LogInButtons from './LogInButtons';
import extractText from '../../common/utils/extractText';
import ItemList from '../../common/utils/ItemList';
import Stream from '../../common/utils/Stream';
export default class SignUpModal extends FormModal {
  constructor() {
    super(...arguments);
    /**
     * The value of the username input.
     */
    _defineProperty(this, "username", void 0);
    /**
     * The value of the email input.
     */
    _defineProperty(this, "email", void 0);
    /**
     * The value of the password input.
     */
    _defineProperty(this, "password", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.username = Stream(this.attrs.username || '');
    this.email = Stream(this.attrs.email || '');
    this.password = Stream(this.attrs.password || '');
  }
  className() {
    return 'Modal--small SignUpModal';
  }
  title() {
    return app.translator.trans('core.forum.sign_up.title');
  }
  content() {
    return [m("div", {
      className: "Modal-body"
    }, this.body()), m("div", {
      className: "Modal-footer"
    }, this.footer())];
  }
  isProvided(field) {
    var _this$attrs$provided$, _this$attrs$provided;
    return (_this$attrs$provided$ = (_this$attrs$provided = this.attrs.provided) == null ? void 0 : _this$attrs$provided.includes(field)) != null ? _this$attrs$provided$ : false;
  }
  body() {
    return [!this.attrs.token && m(LogInButtons, null), m("div", {
      className: "Form Form--centered"
    }, this.fields().toArray())];
  }
  fields() {
    const items = new ItemList();
    const usernameLabel = extractText(app.translator.trans('core.forum.sign_up.username_placeholder'));
    const emailLabel = extractText(app.translator.trans('core.forum.sign_up.email_placeholder'));
    const passwordLabel = extractText(app.translator.trans('core.forum.sign_up.password_placeholder'));
    items.add('username', m("div", {
      className: "Form-group"
    }, m("label", {
      className: "label"
    }, usernameLabel), m("input", {
      className: "FormControl",
      name: "username",
      type: "text",
      placeholder: usernameLabel,
      "aria-label": usernameLabel,
      bidi: this.username,
      disabled: this.loading || this.isProvided('username')
    })), 30);
    items.add('email', m("div", {
      className: "Form-group"
    }, m("label", {
      className: "label"
    }, emailLabel), m("input", {
      className: "FormControl",
      name: "email",
      type: "email",
      placeholder: emailLabel,
      "aria-label": emailLabel,
      bidi: this.email,
      disabled: this.loading || this.isProvided('email')
    })), 20);
    if (!this.attrs.token) {
      items.add('password', m("div", {
        className: "Form-group"
      }, m("label", {
        className: "label"
      }, passwordLabel), m("input", {
        className: "FormControl",
        name: "password",
        type: "password",
        autocomplete: "new-password",
        placeholder: passwordLabel,
        "aria-label": passwordLabel,
        bidi: this.password,
        disabled: this.loading
      })), 10);
    }
    items.add('submit', m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('core.forum.sign_up.submit_button'))), -10);
    return items;
  }
  footer() {
    return [m("p", {
      className: "SignUpModal-logIn"
    }, app.translator.trans('core.forum.sign_up.log_in_text', {
      a: m(Button, {
        className: "Button Button--text Button--link",
        onclick: this.logIn.bind(this)
      })
    }))];
  }

  /**
   * Open the log in modal, prefilling it with an email/username/password if
   * the user has entered one.
   */
  logIn() {
    const attrs = {
      identification: this.email() || this.username()
    };
    app.modal.show(() => import(/* webpackChunkName: 'forum/components/LogInModal', webpackMode: 'lazy-once' */ './LogInModal'), attrs);
  }
  onready() {
    if (this.attrs.username && !this.attrs.email) {
      this.$('[name=email]').select();
    } else {
      this.$('[name=username]').select();
    }
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    const body = this.submitData();
    app.request({
      url: app.forum.attribute('baseUrl') + '/register',
      method: 'POST',
      body,
      errorHandler: this.onerror.bind(this)
    }).then(() => window.location.reload(), this.loaded.bind(this));
  }

  /**
   * Get the data that should be submitted in the sign-up request.
   */
  submitData() {
    const authData = this.attrs.token ? {
      token: this.attrs.token
    } : {
      password: this.password()
    };
    const data = _objectSpread({
      username: this.username(),
      email: this.email()
    }, authData);
    return data;
  }
}
flarum.reg.add('core', 'forum/components/SignUpModal', SignUpModal);flarum.reg.addChunkModule('226', '1793', 'core', 'forum/components/LogInModal');
flarum.reg.addChunkModule('226', '1793', 'core', 'forum/components/ForgotPasswordModal');